import { createSelector } from 'reselect';
import sysUtils from 'utils/ShopYourStore';

import { showShopYourStoreSearchBarAbTestSelector } from 'viewModel/selectors/testTarget/showShopYourStoreSearchBarAbTestSelector';

const isShopYourStoreSearchBarEnabledSelector = createSelector(showShopYourStoreSearchBarAbTestSelector, showShopYourStoreSearchBarAbTest => {
    const globalKillswitch = sysUtils.shopYourStoreV2Enabled();
    const isShopYourStoreSearchBarEnabled = globalKillswitch && showShopYourStoreSearchBarAbTest;

    return isShopYourStoreSearchBarEnabled;
});

export { isShopYourStoreSearchBarEnabledSelector };
